import React, {useEffect, useState} from 'react';
import BackServer from "../../api/BackServer";
import {Button, Grid, Select, TableCell, TableRow, TextField} from "@mui/material";
import ModalStocks from "../modalStocks/modalStocks";
import OneCategoryGlassNew from "../OneCategoryGlassNew/OneCategoryGlassNew";
import {baseUrl_back} from "../../api/BaseUrl";
import SendIcon from '@mui/icons-material/Send';
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import {Col, InputNumber, Row} from "antd";
import Divider from "@mui/material/Divider";
import OneStock from "../OneStock/OneStock";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Flex, Radio } from 'antd';
import { TbSortAscendingNumbers } from "react-icons/tb";
import { TbSortDescendingNumbers } from "react-icons/tb";
import { TbSortAscendingLetters } from "react-icons/tb";
import OneColor from "../OneColor/OneColor";


function SettingOutlined() {
    return null;
}

const NewColors = () => {
    const [stks, setstks] = useState([])
    const [options, setOptions] = useState([
        { value: '1' },
        { value: '1' },
        { value: '1' },
    ])
    const [options2, setOptions2] = useState([
        { value: '2' },
        { value: '2' },
        { value: '2' },
    ])
    const [art, setart] = useState("-")
    const [sort, setSort] = useState("0")
    const [nme, setnme] = useState("Вулкан")
    let xsort ="0"


    // const listener = event => {
    //     if (event.code === "Enter" || event.code === "NumpadEnter") {
    //         console.log("Enter key was pressed. Run your function.");
    //         event.preventDefault();
    //         getStocks();
    //     }
    // };

    const getStocks = async () => {
        setstks([])
        // alert(art)
        const response = await BackServer.getAllArticlesW(art,nme,xsort)
        console.log(response.dta)
        setstks(response.dta)
        setOptions(response.dta1)
        setOptions2(response.dta2)
    }


    function clickEnter(){
        alert("ssss")
    }
    function setSorting(e) {
        // alert(e.target.value)
        // setSort(e.target.value);
        // setstks([])
        xsort=e.target.value
        // alert("dd")
        getStocks()
    }

    function handleChangex(e) {
        setart(e.target.value);
        // alert(art)
    }
    function handleChangey(e) {
        setnme(e.target.value);
    }
    function handleChangey(e) {
        setnme(e.target.value);
    }

    function refr(e) {
        // getAllColors()
        getStocks()
    }
    useEffect(() => {

        // document.addEventListener("keydown", listener);
        // return () => {
        //     document.removeEventListener("keydown", listener);
        // };
        getStocks()
    }, [])

    function handleChange() {

    }


    return (
        <>



            <TextField
                sx={{ mt: 2 }}
                id="outlined-disabled"
                label="Название"
                defaultValue={nme}
                value={nme}
                onChange={handleChangey}

            />
            <TextField
                sx={{ mt: 2 }}
                id="outlined-disabled"
                label="Артикул"
                defaultValue={art}
                value={art}
                onChange={handleChangex}
                onE={clickEnter}

            />
            <Button  sx={{ mt: 2 }} variant="contained" onClick={getStocks}>Найти</Button>
            <p> </p>
            {/*    <div sx={{ mt: 2 }}>*/}
            {/*    <Radio.Group onChange={setSorting} size="medium" defaultValue="0" buttonStyle="solid">*/}
            {/*    <Radio.Button la value="0">нет</Radio.Button>*/}
            {/*    <Radio.Button value="1"><TbSortAscendingNumbers /></Radio.Button>*/}
            {/*    <Radio.Button value="-1"><TbSortDescendingNumbers /></Radio.Button>*/}

            {/*</Radio.Group>*/}
            {/*    </div>*/}
            <Divider>Остатки</Divider>
            <Row gutter={5}>
                <Col span={2}>
                    <Button variant="contained" size="medium" block fullWidth>Артикул</Button>
                </Col>
                <Col span={8}>
                    <Button variant="contained" size="medium" block fullWidth>Название</Button>
                </Col>
                <Col span={5}>
                    <Button variant="contained" size="medium" block fullWidth>"Цвет"</Button>
                </Col>
                <Col span={1}>
                    <Button variant="contained" size="medium" fullWidth><SendIcon/></Button>
                </Col>
                <Col span={5}>
                    <Button variant="contained" size="medium" block fullWidth>"Справочно"</Button>
                </Col>
                {/*<Col span={2}>*/}
                {/*    <Radio.Group block onChange={setSorting} size="medium" defaultValue="0" buttonStyle="solid">*/}
                {/*        <Radio.Button la value="0">нет</Radio.Button>*/}
                {/*        <Radio.Button value="1"><TbSortAscendingNumbers /></Radio.Button>*/}
                {/*        <Radio.Button value="-1"><TbSortDescendingNumbers /></Radio.Button>*/}

                {/*    </Radio.Group>*/}
                {/*</Col>*/}
                {/*<Col  span={1}>*/}
                {/*    <Button variant="contained" size="medium" block fullWidth><RefreshIcon/></Button>*/}
                {/*</Col>*/}


            </Row>
            {/*<Row gutter={5}>*/}
            {stks.map((elm, key) => (
                <OneColor options={options} options2={options2} datas={elm}></OneColor>
                // <li key={key}> {elm}</li>
            ))}

            {/*<Grid container spacing={1}>*/}
            {/*    <Grid container item spacing={1}>*/}
            {/*        <Grid item key={12}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>Артикул</Button>*/}
            {/*        </Grid>*/}

            {/*        <Grid item key={123}  lg={5} xl={5} sm={5} md={5} xs={5}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>Название</Button>*/}
            {/*        </Grid>*/}
            {/*        <Grid item key={1234}  lg={2} xl={2} sm={2} md={2} xs={2}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>"Цвет"</Button>*/}
            {/*        </Grid>*/}
            {/*        <Grid item key={1245}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>Кол</Button>*/}
            {/*        </Grid>*/}

            {/*        <Grid item key={3121}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*            <Button variant="contained" size="medium" fullWidth><SendIcon/></Button>*/}
            {/*        </Grid>*/}
            {/*    </Grid>*/}


            {/*    {stks.map((elm, key) => (*/}
            {/*        <>*/}
            {/*        <Grid container item spacing={1}>*/}
            {/*        <Grid item key={elm.value._id+"r"}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>{elm.value._id}</Button>*/}
            {/*        </Grid>*/}

            {/*        <Grid item key={elm.value._id+"z"}  lg={5} xl={5} sm={5} md={5} xs={5}>*/}
            {/*            <Button variant="contained" size="medium" block fullWidth>{elm.value.shortName}</Button>*/}
            {/*        </Grid>*/}
            {/*            <Grid item key={elm.value._id+"y"}  lg={2} xl={2} sm={2} md={2} xs={2}>*/}
            {/*                <Button variant="contained" size="medium" block fullWidth>{elm.value.Color}</Button>*/}
            {/*            </Grid>*/}
            {/*            <Grid item key={elm.value._id+"x"}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*                /!*<Button variant="contained" size="medium" block fullWidth>{elm.value.present}</Button>*!/*/}
            {/*                <TextField*/}
            {/*                    hiddenLabel*/}
            {/*                    id="filled-hidden-label-small"*/}
            {/*                    defaultValue={elm.value.present}*/}
            {/*                    variant="filled"*/}
            {/*                    size="small"*/}
            {/*                    select*/}
            {/*                >*/}
            {/*                    {currencies.map((option) => (*/}
            {/*                        <MenuItem key={option.value} value={option.value}>*/}
            {/*                            {option.label}*/}
            {/*                        </MenuItem>*/}
            {/*                    ))}*/}
            {/*                </TextField>*/}

            {/*            </Grid>*/}

            {/*            <Grid item key={elm.value._id}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*                <ModalStocks  key={elm.value._id} nme={elm.value._id} art={elm.value.present}></ModalStocks>*/}
            {/*            </Grid>*/}
            {/*            <Grid item key={key}  lg={1} xl={1} sm={1} md={1} xs={1}>*/}
            {/*                <Button variant="contained" size="medium" fullWidth><SendIcon/></Button>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*        </>*/}
            {/*))}*/}
            {/*</Grid>*/}



            {/*<li>{row.value.shortName}</li>*/}
            {/*<li>{row.value._id}</li>*/}
            {/*<li>{row.value.Color}</li>*/}
            {/*<li>{row.value.present}</li>*/}
        </>

    );
};


export default NewColors;